import React from 'react';
import styled from 'styled-components';
import { node, string } from 'prop-types';

const Section = ({ children, className }) => {
  return <StyledSection className={className}>{children}</StyledSection>;
};

const StyledSection = styled.section`
  width: 100%;
  margin: auto;
  max-width: 100rem;
  margin-top: 4.5rem;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: bold;
`;

const Subtitle = styled.h2`
  font-size: 1.5rem;
  color: #505050;
`;
const Content = styled.div`
  background-color: white;
  position: relative;
  font-size: 1.5rem;
  padding: 3.5rem;
  border: 0.1rem solid ${({ theme }) => theme.ui.background};
  box-shadow: 0 0.2rem 0.5rem rgba(0, 0, 0, 0.05);
  border-radius: 0.5rem;
  margin-top: 2rem;
`;

Section.propTypes = {
  children: node,
  className: string,
};

Section.Title = Title;
Section.Subtitle = Subtitle;
Section.Content = Content;

export default Section;
